import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { LoadingIndicationService } from "../services/loading-indication.service";

@Injectable({ providedIn: "root" })
export class LoadingIndicationInterceptor implements HttpInterceptor {
  constructor(private loadingIndicationService: LoadingIndicationService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.loadingIndicationService.show(request.url);
    return next
      .handle(request)
      .pipe(finalize(() => this.loadingIndicationService.hide(request.url)));
  }
}
